import { get, post } from './request'

export let paginate = (path, success, failure) => {
  return get (
    `api${path}`, success, failure
  )
}

export let all = (success, failure) => {
  return get(
    `api/cms/pages/all`, success, failure
  )
}

export let load = (page, success, failure) => get(
  `api/cms/page/${page}`, success, failure
)

export let create = (page, success, failure) => post(
  `api/cms/page/create`, page, success, failure
)

export let save = (page, success, failure) => post(
  `api/cms/page/${page.id}/update`, page, success, failure
)

export let remove = (page, success, failure) => post(
  `api/cms/page/${page}/remove`, {}, success, failure
)

